import React from 'react';
import Highlight from 'react-scale/components/elements/highlight';
import TaskResponseVideo from '../tasks/TaskResponseVideo';

export const instruction = 'Draw a polygon around each label.';

export const responseCode = `{
  "annotations": {
    "url": "https://scaleapi-results.s3.us-west-1.amazonaws.com/4b7c4bd0-b1ee-11e8-b472-b39f604468d8",
  },
}`;

export const code = `client.createVideoannotationTask(
  {
    callback_url: 'http://www.example.com/callback',
    instruction: '${instruction}',
    attachment_type: 'video',
    attachment: 'http://example.com/video.mp4',
    objects_to_annotate: ['Couch', 'Coffee Table', 'TV Stand', 'Dining Table', 'Chair'],
    with_labels: true,
    annotation_grouping: true
  },
  (err, task) => {
    // do something with task
  }
);`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);
const annotatedMuxPlaybackID = 'ihNOQJWw9dS5Wd02cBpPO02ZBquvSTlyp3';
const originalMuxPlaybackID = 'Mqhxb2aLT7sAIK4L64oXBtbR1IyYYgIu';

const component = ({ refAsync }) => (
  <TaskResponseVideo
    annotatedMuxPlaybackID={annotatedMuxPlaybackID}
    originalMuxPlaybackID={originalMuxPlaybackID}
    ref={refAsync}
  />
);

export const example = { component };

export const result = null;
